import PropTypes from 'prop-types';
import React from 'react';
// -*- mode: jsx;-*-
import { LoadingEllipsis } from '../common/LoadingEllipsis.js';
import { getPage } from '../common/requestUtils.js';
import { SupporterMessageList } from '../common/SupporterMessageList.js';
import { Tabs } from '../common/Tabs.js';
import TabSelector from './TabSelector.js';
import ActiveProjects from './ActiveProjects.js';
import FundedProjects from './FundedProjects.js';

let TabLayout = function (props) {
    let content;
    if (props.loading) {
        content = <LoadingEllipsis/>;
    } else {
        const page = getPage(props.url);

        switch (props.activeTabName) {
        case 'UPDATES':
            content = <SupporterMessageList data={props.data} page={page}
                isMobile={props.isMobile} changeURL={props.changeURL}
                challengeId={(props.challenge.id).toString()}/>;
            break;
        case 'ACTIVE':
            content = <ActiveProjects data={props.data} page={page} changeURL={props.changeURL}
                isMobile={props.isMobile} showGiveWidget={props.showGiveWidget}
                toggleGiveWidget={props.toggleGiveWidget}
                perPage={props.perPage} isPartnerPage={props.isPartnerPage}/>;
            break;
        case 'HISTORICAL':
            content = <FundedProjects data={props.data} page={page}
                isMobile={props.isMobile} changeURL={props.changeURL}
                perPage={props.perPage} isPartnerPage={props.isPartnerPage}/>;
            break;
        default:
            // if a user clicks an open tab on mobile, closeTab() will be called, and props.activeTabName will be null. that's okay.
        }
    }

    return (
        <div className="col col9 tabs-wrapper">
            <TabSelector {...props} />
            <Tabs {...props} isMobileDropdownStyle={true}/>
            {content}
        </div>
    );
};

TabLayout.propTypes = {
    challenge: PropTypes.object.isRequired,
    loading: PropTypes.bool.isRequired,
    url: PropTypes.string.isRequired,
    isMobile: PropTypes.bool.isRequired,
    activateTab: PropTypes.func.isRequired,
    changeURL: PropTypes.func.isRequired,
    closeTab: PropTypes.func.isRequired,
    toggleGiveWidget: PropTypes.func.isRequired,

    activeTab: PropTypes.object,
    activeTabName: PropTypes.string,
    isPartnerPage: PropTypes.bool,
    perPage: PropTypes.number,
    showGiveWidget: PropTypes.bool,
    data: PropTypes.object,
};
TabLayout = React.memo(TabLayout);
export default TabLayout;
